import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { General_Interface } from 'src/app/Interface/General_Interface';
import { Empty_Textletter_Interface, Textletter_Interface } from 'src/app/Interface/Textletter_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { SubjectLetterService } from 'src/app/Service/SubjectLetter/SubjectLetter.service';
import { TextletterService } from 'src/app/Service/Textletter/Textletter.service';

@Component({
  selector: 'app-TextletterAdd',
  templateUrl: './TextletterAdd.component.html',
  styleUrls: ['./TextletterAdd.component.scss']
})
export class TextletterAddComponent implements OnInit {

  constructor(
    private SubjectLetter_Service:SubjectLetterService,
    private Textletter_Service:TextletterService,
    private Nav_Service:NavService,
    private Alertify_Service:AlertifyService
  ) { }

  ngOnInit() {

    this.AddNewTextletter=new FormGroup({
      id :new FormControl(),
      Subject_id:new FormControl('0',Validators.required),
      Dsc:new FormControl(null,Validators.required),
      Code:new FormControl(null,Validators.required),
      Semat:new FormControl(null,Validators.required),
      Name:new FormControl(null,Validators.required),
    })


    this.Nav_Service.CheckValidPage(43).subscribe(
      data=>{
        this.ReadData_SubjectLetter()
      }
      ,error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )


  }


  //#region  Form Add

  AddNewTextletter:FormGroup;

  get_Form_Subject_id(){
    return this.AddNewTextletter.get('Subject_id') as FormControl;
  }

  get_Form_Dsc(){
    return this.AddNewTextletter.get('Dsc') as FormControl;
  }

  get_Form_Semat(){
    return this.AddNewTextletter.get('Semat') as FormControl;
  }

  get_Form_Code(){
    return this.AddNewTextletter.get('Code') as FormControl;
  }

  get_Form_Name(){
    return this.AddNewTextletter.get('Name') as FormControl;
  }

  //#endregion

  InProccessing:boolean=false

  SubmitAddNewTextletter(){

    if(this.get_Form_Subject_id().value=="0")
    {
      this.Alertify_Service.ErrorMessage("موضوع نامه را انتخاب نمائید")
    }
    else{
      var Record:Textletter_Interface =Empty_Textletter_Interface()
      Record.id=0
      Record.semat=this.get_Form_Semat().value
      Record.dsc=this.get_Form_Dsc().value
      Record.code=this.get_Form_Code().value
      Record.name=this.get_Form_Name().value
      Record.subject_id=Number(this.get_Form_Subject_id().value)
      this.InProccessing=true
      this.Textletter_Service.AddText_letter(Record).subscribe(
        data=>{
          this.InProccessing=false
          if(data.id==-2){
            this.Alertify_Service.ErrorMessage("عنوان وارد شده ، در لیست وجود دارد")
          }
          else{
            this.AddNewTextletter.reset()
            this.Alertify_Service.SuccessMessage("اطلاعات ثبت شد")
          }
        },error=>{
          // AuthInterceptor owns authentication; feature errors must preserve credentials.

        }
      )

    }

  }


  ////  SubjectLetter
  DataList_SubjectLetter:Array<General_Interface>=[]
  ReadData_SubjectLetter(){
    this.SubjectLetter_Service.GetActiveList().subscribe(
      data=>{
        this.DataList_SubjectLetter=data
      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

}
